import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, Image } from "../../../../AbstractElements";
import { GalleryTitle, HoverEffect, ImageHoverEffectsTitle } from "../../../../Constants/Constants";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Fragment } from "react/jsx-runtime";

const GalleryHoverContainer = () => {
  const hoverImageData = [8, 9, 10, 11];
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ImageHoverEffectsTitle} parent={GalleryTitle} />
      <Container fluid>
        {dynamicNumber(15).map((item, i) => (
          <Row key={i}>
            <Col sm="12">
              <Card>
                <CommonCardHeader title={`${HoverEffect} ${item}`} />
                <CardBody>
                  <Row id="aniimated-thumbnials" className="my-gallery gallery">
                    {hoverImageData.map((image, index) => (
                      <Col xs="6" md="3" key={index}>
                        <figure itemProp="associatedMedia" className={`img-hover hover-${item}`} key={i}>
                          <div>
                            <Image className="img-fluid" src={dynamicImage(`lightgallry/0${image}.jpg`)} alt="Image description" />
                          </div>
                        </figure>
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ))}
      </Container>
    </Fragment>
  );
};

export default GalleryHoverContainer;
